/**
 * @param {string} country
 * @returns {*}
 */
function postalCode (country) {
  if (!country) return
  return require('./locales')?.[country]?.postalCode()
}

module.exports = { postalCode }
